import React from 'react';
import './oneof.css';
import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";
import { RoundButton } from './roundbutton';

interface Props {
    index : number;
    n     : number;

    onPrev : (id : number) => void;
    onNext : (id : number) => void;
}

export class OneOf extends React.Component<Props> {

    render() {
        return (
            <div className="message-oneof">
                <RoundButton
                    icon={GrPrevious}
                    disabled={ this.props.index === 0 }
                    size={12}
                    onClick={() => {this.props.onPrev(this.props.index - 1) } } />
                <div className="one-of-text"><span>{this.props.index + 1} of {this.props.n}</span></div>
                <RoundButton
                    icon={GrNext}
                    disabled={ this.props.index === this.props.n - 1 }
                    size={12}
                    onClick={() => {this.props.onNext(this.props.index + 1) } } />
            </div>
        );
      }
}

